export const search = (state, payload) => {
  state.currentSearch = payload;
};
export const setNewGlobalAction = (state,payload)=>{
  state.currentAction = payload;
}